import { render, staticRenderFns } from "./position-user-modal.vue?vue&type=template&id=0ea1ed6d&scoped=true"
import script from "./position-user-modal.vue?vue&type=script&lang=js"
export * from "./position-user-modal.vue?vue&type=script&lang=js"
import style0 from "./position-user-modal.vue?vue&type=style&index=0&id=0ea1ed6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1ed6d",
  null
  
)

export default component.exports